module.exports = __webpack_public_path__ + "static/media/bell-school.2827a9a9.svg";